import { leaguesV2Api } from "../leaguesV2Api";
import type { Clubhouse_LeagueOperatorDashboardDto } from "../../types/leagues";

export interface GetDashboardQueryArgs {
  includeArchived?: boolean;
  facilityId?: string;
  attentionOnly?: boolean;
}

function pickDashboardParams(
  args: GetDashboardQueryArgs,
): Record<string, string | boolean> | undefined {
  const params: Record<string, string | boolean> = {};
  if (args.includeArchived !== undefined) {
    params.includeArchived = args.includeArchived;
  }
  if (args.facilityId !== undefined && args.facilityId !== "") {
    params.facilityId = args.facilityId;
  }
  if (args.attentionOnly !== undefined) {
    params.attentionOnly = args.attentionOnly;
  }
  return Object.keys(params).length > 0 ? params : undefined;
}

const dashboardEndpoints = leaguesV2Api.injectEndpoints({
  endpoints: (build) => ({
    getDashboard: build.query<
      Clubhouse_LeagueOperatorDashboardDto,
      GetDashboardQueryArgs | void
    >({
      query: (args) => ({
        url: "/api/leagues/dashboard",
        params: pickDashboardParams(args ?? {}),
      }),
      providesTags: ["Dashboard"],
    }),
  }),
});

export const { useGetDashboardQuery } = dashboardEndpoints;
